var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"categoryList"},_vm._l((_vm.navData),function(item){return _c('div',{key:item.ID,staticClass:"item",class:_vm.isActive === item.ID ? 'is-active':'',attrs:{"title":item.NAME},on:{"click":function($event){return _vm.handleNav(item)}}},[_vm._v(_vm._s(item.NAME))])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a2307dc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/categry/components/LeftMenu.vue
// module id = null
// module chunks = 